module.exports = __webpack_public_path__ + "static/media/modelo-c.29d86201.png";